import { useState, useEffect } from 'react';
import { Container, Title, Table, Loader, Alert, Progress } from '@mantine/core';
import api from '@/config/api';

interface LeaveBalance {
  leave_type: string;
  accrued: number;
  used: number;
  available: number;
  max_accrual: number;
}

export default function LeaveBalances() {
  const [balances, setBalances] = useState<LeaveBalance[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.get('/hr/my/leave-balances')
      .then(res => setBalances(res.data?.balances || []))
      .catch(err => setError(err.response?.data?.detail || 'Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader mx="auto" mt="xl" />;
  if (error) return <Alert color="red" title="Error">{error}</Alert>;

  return (
    <Container size="lg">
      <Title order={2} mb="lg">Leave Balances</Title>
      {balances.length === 0 ? (
        <Alert color="blue">No leave balances found.</Alert>
      ) : (
        <Table striped>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Leave Type</Table.Th>
              <Table.Th>Accrued</Table.Th>
              <Table.Th>Used</Table.Th>
              <Table.Th>Available</Table.Th>
              <Table.Th>Usage</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {balances.map(b => (
              <Table.Tr key={b.leave_type}>
                <Table.Td>{b.leave_type}</Table.Td>
                <Table.Td>{b.accrued}h</Table.Td>
                <Table.Td>{b.used}h</Table.Td>
                <Table.Td>{b.available}h</Table.Td>
                <Table.Td style={{ width: 150 }}>
                  <Progress value={b.max_accrual > 0 ? (b.used / b.max_accrual) * 100 : 0} size="lg" />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Container>
  );
}
